import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-debit-credit-card',
  templateUrl: './debit-credit-card.component.html',
  styleUrls: ['./debit-credit-card.component.scss']
})
export class DebitCreditCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
